import {
  MaterialCiqIcon,
  ScheduleCiqIcon,
  SubmittalCiqIcon
} from "components/svg-icons";
import { useMemo } from "react";
import BidPackageCiqIcon from "./bid-package-ciq-icon";
import DesignPackageCiqIcon from "./design-package-ciq-icon";

function CiqIconCircle({
  feature,
  size = 12,
  padding = 8
}: {
  size?: number;
  padding?: number;
  feature:
    | "MATERIALS"
    | "SUBMITTALS"
    | "DESIGN_PACKAGE"
    | "BID_PACKAGE"
    | "SCHEDULES";
}) {
  const getInfo = useMemo(() => {
    switch (feature) {
      case "MATERIALS":
        return {
          icon: (
            <MaterialCiqIcon
              size={size}
              className="fill-ciq-blue-400-alt"
              opacity="1"
            />
          ),
          color: "var(--ciq-blue-250)"
        };
      case "SUBMITTALS":
        return {
          icon: (
            <SubmittalCiqIcon
              size={size}
              className="fill-ciq-primary-900"
              opacity="1"
            />
          ),
          color: "var(--ciq-primary-900-light)"
        };
      case "SCHEDULES":
        return {
          icon: (
            <ScheduleCiqIcon
              size={size}
              className="fill-ciq-orange-890"
              opacity="1"
            />
          ),
          color: "var(--ciq-orange-870)"
        };
      case "BID_PACKAGE":
        return {
          icon: (
            <BidPackageCiqIcon
              size={size}
              className="fill-ciq-blue-250"
              opacity="1"
            />
          ),
          color: "var(--ciq-blue-600)"
        };
      case "DESIGN_PACKAGE":
        return {
          icon: (
            <DesignPackageCiqIcon
              size={size}
              className="fill-ciq-golden-purple-6"
              opacity="1"
            />
          ),
          color: "var(--ciq-golden-purple-7)"
        };

      default:
        break;
    }
    return { icon: null, color: "white" };
  }, [feature, size]);

  return (
    <div
      className="flex items-center justify-center rounded-full"
      style={{ padding, backgroundColor: getInfo.color }}
    >
      {getInfo.icon}
    </div>
  );
}
export default CiqIconCircle;
